import { render } from "./AddClientView.vue?vue&type=template&id=2b8ece4c&scoped=true"
import script from "./AddClientView.vue?vue&type=script&lang=js"
export * from "./AddClientView.vue?vue&type=script&lang=js"

import "./AddClientView.vue?vue&type=style&index=0&id=2b8ece4c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8ece4c"]])

export default __exports__